import React from "react";
import { content } from "../../data";
import Marquee from "react-fast-marquee";

const NftMarquee = () => {
  const nftCollection = content.MarqueNFTs;

  return (
    <Marquee>
      <div className="flex items-center justify-center bg-[#252525] py-6 mb-14 border-y border-regular-orange">
        {nftCollection.map((item, index) => {
          const height = index % 2 === 0 ? "180px" : "160px";
          const width = index % 2 === 0 ? "160px" : "135px";
          const position = index % 2 === 0 ? "-top-2" : "-bottom-5";

          return (
            <div
              key={index}
              className={`mr-10 border yellow-border rounded-md overflow-hidden w-fit relative ${position}`}
              style={{ height, width }}
            >
              <img
                src={item.imgUrl}
                alt="NFT Cards Marquee"
                className="w-full h-full object-cover"
              />
            </div>
          );
        })}
      </div>
    </Marquee>
  );
};

export default NftMarquee;
